// Em que ambiente este build está rodando. O CRA embute as variáveis
// `REACT_APP_*` em tempo de build, então a decisão é do build e não pode ser
// mudada por quem usa o sistema.
//
// - UAT (homologação): `deploy-uat.yml` builda com `REACT_APP_ENVIRONMENT=uat`.
// - Desenvolvimento local (`npm start`): `NODE_ENV === "development"`.
// - Produção: nenhuma das duas, então tudo que depende disto fica desligado.

export const isUatEnvironment = () =>
  process.env.REACT_APP_ENVIRONMENT === "uat";

// UAT ou máquina de desenvolvimento: onde recursos só de teste podem existir.
export const isTestEnvironment = () =>
  isUatEnvironment() || process.env.NODE_ENV === "development";

// Página aberta dentro de um iframe: é o caso da simulação de celular/tablet
// do UAT (`UatViewportShortcut`), que abre o app dentro de um iframe.
export const isEmbeddedFrame = () => {
  try {
    return window.self !== window.top;
  } catch (error) {
    return true; // acesso a window.top bloqueado = há um frame de outra origem
  }
};
